<template>
  <div class="right-item hover-change-color-all">
    <div class="box-time">
      <!-- <p>{{ dayjs(info.release_time * 1000).format("DD") }}</p>
      <p>{{ dayjs(info.release_time * 1000).format("YYYY/MM") }}</p> -->
    </div>
    <!-- <div class="box-line"></div> -->
    <div class="box-info" @click="clickButton(info.id)">
      <p>
         {{ info.title }}
        
      </p>
      <p>
         {{ info.intro }}
         
      </p>
      <p>
        {{ dayjs(info.release_time * 1000).format("YYYY/MM/DD") }}
      </p>
    </div>
  </div>
</template>

<script setup>
import { reactive } from "vue";
import { useRouter } from "vue-router";
import dayjs from "dayjs";

const router = useRouter();

const mydata = reactive({
  path: "",
  // 基础地址
  // VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
});

const props = defineProps({
  path: {
    type: String,
    // default: "",
  },
  info: {
    type: Object,
    default: () => {
      return {};
    },
  },
});

//按钮点击事件
function clickButton(id) {
  router.push({
    path: props.path,
    query:{id}
  });
}


</script>


<style scoped lang="scss">
.box-info {
  width: 343px;
  height: 100%;
  // border:1px solid red;
  // display: flex;
  // flex-direction: column;
  // justify-content: center;
  border-bottom: 1px solid #cccccc;
  padding-bottom: 12px;
  > p:nth-of-type(1) {
    font-size: 16px;
    font-weight: 700;
    color: #333333;

    line-height: 24px;
    white-space: nowrap; //不折行
    text-overflow: ellipsis; //文本溢出 用省略号显示
    overflow: hidden;
    // margin-bottom: 12px;

    // display: -webkit-box;
    // -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
    // text-overflow: ellipsis; //文本溢出 用省略号显示
    // -webkit-line-clamp: 2; //几行
    // overflow: hidden;

    cursor: pointer;
  }
  > p:nth-of-type(2) {
    height: 44px;
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    line-height: 22px;
    margin-top: 12px;

    display: -webkit-box;
    -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
    text-overflow: ellipsis; //文本溢出 用省略号显示
    -webkit-line-clamp: 2; //几行
    overflow: hidden;

    cursor: pointer;
  }
  > p:nth-of-type(3) {
    font-size: 12px;
    font-weight: 400;
    color: #666666;
    margin-top: 12px;
  }
  // >p:hover{
  //    color:#009DE0;
  // }
}
</style>
